import React from 'react';
import { Colors, Text } from 'library';
import { Grid } from '@mui/material';
import FaqAnswer, { IFAQQuestion } from 'parent-portal/business-profile/BusinessFaq/FaqAnswer';
import { IBusinessLocation } from 'models';

export default function BusinessFaqSection({
    faqQuestions,
    updateQuestion,
    businessLocation,
}: {
    faqQuestions: IFAQQuestion[];
    updateQuestion: (q: IFAQQuestion) => void;
    businessLocation: IBusinessLocation;
}) {
    const BooleanAnswerText = [
        'Prevent providers from clocking in early?',
        'Prevent providers from clocking out late?',
    ];
    const viewableQuestions = faqQuestions.filter((q) => !BooleanAnswerText.includes(q.question));
    return (
        <Grid
            container
            item
            style={{ backgroundColor: Colors.white, borderRadius: 18, padding: 20 }}
            direction="column"
        >
            <Text variant="body1" bold>
                Frequently Asked Questions
            </Text>
            {viewableQuestions.map((q: any) => (
                <FaqAnswer key={q.question} question={q} location={businessLocation} updateQuestion={updateQuestion} />
            ))}
        </Grid>
    );
}
